import React, { useState, useEffect } from "react";
import { Modal, Input, Button, Typography, message, Row, Col } from "antd";
import { platformApi } from "../../../../api";

const { Text, Title } = Typography;

const GatePassOtpModal = ({
  open,
  onCancel,
  jobOrder,
}) => {
  const [mobileNo, setMobileNo] = useState("");
  const [otpGenerated, setOtpGenerated] = useState(false);
  const [generating, setGenerating] = useState(false);

  useEffect(() => {
    if (open && jobOrder) {
      const phone =
        jobOrder.customerPhone ||
        jobOrder.customer?.contacts?.[0]?.phone ||
        jobOrder.customer?.CustomerPhone?.[0]?.phone ||
        "";
      setMobileNo(phone);
      setOtpGenerated(false);
    } else if (!open) {
      setMobileNo("");
      setOtpGenerated(false);
      setGenerating(false);
    }
  }, [open, jobOrder]);

  const isGenerateEnabled = Boolean(mobileNo && mobileNo.trim().length >= 10);

  const handleGenerateOtp = async () => {
    if (!isGenerateEnabled || generating) return;
    setGenerating(true);
    try {
      const res = await platformApi.post("/api/jobOrder/gatePass/generateOtp", {
        jobOrderId: jobOrder.id,
        mobile: mobileNo.trim(),
      });
      const payload = res?.data?.response || res?.data;
      const ok =
        res?.data?.code === 200 &&
        (payload?.code === 200 || payload?.code == null);
      if (!ok) {
        message.error(payload?.message || "Failed to send Gate Pass OTP");
        return;
      }
      setOtpGenerated(true);
      message.success("OTP sent to customer on WhatsApp");
    } catch (err) {
      console.error("Gate Pass OTP generate error:", err);
      message.error(
        err?.response?.data?.response?.message ||
          err?.response?.data?.message ||
          "Failed to send Gate Pass OTP"
      );
    } finally {
      setGenerating(false);
    }
  };

  const vehicleRegNo =
    jobOrder?.vehicle?.registerNo ||
    jobOrder?.vehicle?.registrationNo ||
    "-";

  return (
    <Modal
      title={
        <div>
          <Title level={4} style={{ margin: 0, fontSize: "18px" }}>
            Gate Pass OTP
          </Title>
          <Text type="secondary" style={{ fontSize: "13px" }}>
            Job No: <strong>{jobOrder?.jobNo || "-"}</strong> &nbsp;|&nbsp; Reg
            No: <strong>{vehicleRegNo}</strong>
          </Text>
        </div>
      }
      visible={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      width={520}
    >
      <div style={{ padding: "10px 0" }}>
        <div style={{ marginBottom: "20px" }}>
          <label
            style={{
              display: "block",
              fontWeight: 600,
              fontSize: "14px",
              marginBottom: "8px",
              color: "#262626",
            }}
          >
            Customer Mobile No:
          </label>
          <Row gutter={10} type="flex" align="middle">
            <Col span={17}>
              <Input
                placeholder="Enter customer mobile no"
                value={mobileNo}
                maxLength={10}
                style={{ fontSize: "15px", height: "40px" }}
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "");
                  setMobileNo(val);
                }}
              />
            </Col>
            <Col span={7}>
              <Button
                type="primary"
                disabled={!isGenerateEnabled || generating}
                loading={generating}
                onClick={handleGenerateOtp}
                style={{
                  height: "40px",
                  width: "100%",
                  fontWeight: 600,
                  fontSize: "14px",
                  backgroundColor: isGenerateEnabled ? "#0d9488" : undefined,
                  borderColor: isGenerateEnabled ? "#0d9488" : undefined,
                  color: isGenerateEnabled ? "#ffffff" : undefined,
                }}
              >
                {otpGenerated ? "Resend" : "Generate"}
              </Button>
            </Col>
          </Row>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "12px",
            marginTop: "10px",
          }}
        >
          <Button
            size="large"
            style={{ minWidth: "90px", fontSize: "14px" }}
            onClick={onCancel}
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default GatePassOtpModal;
